import { Divider } from "@mui/material";
import { Button } from "components";
import {
  useEnableHelena,
  useGetHelenaAccess,
  useGlobalStore,
  useNonPersistantMainStore,
  usePermissionStore,
  useSetMspFeatureFlagAsSeen,
} from "controller";
import { useAtom } from "jotai";
import { useHomeViewMode } from "pages/modules/home-v2/hooks/useHomeViewMode";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AiBannerShell } from "../ai-banner-shell/AiBannerShell";
import { isWithinTrialBannerWindow } from "../trial-banner/TrialBanner";
import { meetAiBannerDismissedAtom } from "./store/meetAiBannerAtoms";

const HOME_ROUTE = "/app/home";

export const MeetAiBanner = () => {
  const navigate = useNavigate();
  const [isDismissed, _setIsDismissed] = useAtom(meetAiBannerDismissedAtom);
  const isSuperAdmin = usePermissionStore((state) => state.isSuperAdmin());
  const isAdmin = usePermissionStore((state) => state.isAdmin());
  const isBannerFlagOn = useNonPersistantMainStore(
    (state) => state.featureFlags?.show_ai_banner === true,
  );
  const isTrialBannerVisible = useGlobalStore((state) =>
    isWithinTrialBannerWindow(state.mspCreatedAt),
  );
  const canSeeBanner =
    isBannerFlagOn &&
    !isDismissed &&
    !isTrialBannerVisible &&
    (isSuperAdmin || isAdmin);
  const { data: helenaAccess, isSuccess: isAccessLoaded } = useGetHelenaAccess({
    enabled: canSeeBanner,
  });
  const { mode: homeViewMode, setMode: setHomeViewMode } = useHomeViewMode();
  const { mutateAsync: enableHelena, isLoading: isEnabling } =
    useEnableHelena();
  const { mutate: setMspFeatureAsSeen } = useSetMspFeatureFlagAsSeen();

  const isAiEnabled = Boolean(helenaAccess?.helena_enabled);

  const handleTryNow = async () => {
    const previousMode = homeViewMode;
    setHomeViewMode("ai");
    try {
      await enableHelena();
      useNonPersistantMainStore.setState((state) => ({
        featureFlags: { ...state.featureFlags, show_ai_banner: false },
      }));
      setMspFeatureAsSeen("show_ai_banner");
      navigate(HOME_ROUTE);
    } catch {
      setHomeViewMode(previousMode);
      toast.error("Unable to enable DeskDay AI");
    }
  };

  if (!(canSeeBanner && isAccessLoaded) || isAiEnabled) return null;

  return (
    <AiBannerShell message="Meet DeskDay AI — Ask Helena, AI Copilot & AI Agents.">
      <Divider orientation="vertical" flexItem sx={{ my: "8px" }} />
      <Button
        variant="ghost"
        isLink
        loading={isEnabling}
        onClick={handleTryNow}
        sx={{ "&:hover": { textDecoration: "underline" } }}
      >
        Try now
      </Button>
    </AiBannerShell>
  );
};
